module.exports = __webpack_public_path__ + "static/media/29FUNOV1.f985166d.jpg";